import axios from 'axios'
import {config} from "../../config";

const api = axios.create({
    baseURL: config.apiBaseUrl,
    withCredentials: false,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
})

const token = localStorage.getItem('auth_token')
if (token) {
    api.defaults.headers.common['Bearer'] = token
}

// Registered here at module load rather than in App.vue's mounted() hook.
// A child component's mounted() fires BEFORE its parent's, so the request a
// page makes on load goes out before App.vue has attached anything - and after
// a session expires that first request is exactly the one that 401s. Handled
// there, it was missed every time.
api.interceptors.response.use(undefined, (error) => {

    const status = error.response && error.response.status

    if (status === 401) {
        localStorage.removeItem('auth_token')
        localStorage.removeItem('user')
        delete api.defaults.headers.common['Bearer']

        // Guard against a redirect loop if the login page itself 401s.
        if (window.location.pathname !== '/') {
            window.location.href = '/'
        }
    }

    return Promise.reject(error)
})

export default api
